import siteFooterTheme from './siteFooterTheme';

const siteFooterDarkTheme = {
    footer: {
        ...siteFooterTheme.defaultFooter,
    },
};

export default siteFooterDarkTheme;
